import { Button, Modal, notification, Space, message as Message } from "antd";
import { DeleteOutlined, LinkOutlined, ShareAltOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { fetchWrapper } from "../../helpers";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const baseUrl = `${process.env.REACT_APP_API_URL}`;

const CreateSeriesOfPostsFromArrayMessageModal = ({ postMessages, snAction, socialNetworks, disabledButton = false }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [messages, setMessages] = useState(postMessages);
    const [fbPageId, setFbPageId] = useState("");
    const [tokens, setTokens] = useState(undefined);
    const navigate = useNavigate();
    const [notificationApi, notificationContextHolder] = notification.useNotification();
    const [isSNModalOpen, setIsSNModalOpen] = useState(false);

    const createPostFromMessage = async (post, index) => {
        // const postTitle = `${`${t('assistan.postTitlePrefix')}${index + 1 || ''}`} - ${post.title?.trim()}`;
        const postTitle = `${`${t("assistant.postTitlePrefix")}${index + 1 || ""}`} - ${post.title?.trim()}`;
        const postContent = `${post.content?.trim()}`;
        const postHashtags = `${post.hashtags}`;
        const postMedia = `${post.media?.trim()}`;
        const date = new Date();

        try {
            const result = await fetchWrapper.post(`${process.env.REACT_APP_API_URL}/assistant/summary`, {
                title: postTitle,
                content: postContent,
                hashtags: postHashtags,
                media: postMedia,
                socialNetwork: socialNetworks,
                date: date.toISOString(),
                isCompletedPost: true,
            });

            if (result) {
                return result;
            }
        } catch (err) {
            console.error(err);
            Message.error(t("functions.wrong"));
            return err;
        }
    };

    const createSeriesPostsFromMessage = async () => {
        const filteredMessages = messages.filter((item) => item?.content?.trim() !== "");
        if (filteredMessages.length < 1) {
            return Message.error(t("assistant.notEnoughPosts"));
        }
        setIsLoading(true);
        Message.loading(t("functions.generating"));

        for (let i = 0; i < filteredMessages.length; i++) {
            const result = await createPostFromMessage(filteredMessages[i], i);
            if (result) {
                console.log(result);
                Message.success(t("assistant.createPostSuccess", { count: i + 1 }));
            } else {
                Message.error(t("assistant.createPostError", { count: i + 1 }));
            }
        }

        setIsLoading(false);
        setIsSNModalOpen(false);
        navigate("/posts");
    };

    const handleEditMessageFromSeries = (index, key, text) => {
        const obj = {};
        if (key === "hashtags") {
            obj[key] = text.split(" ");
        } else {
            obj[key] = text;
        }
        setMessages((prevState) => {
            return prevState.map((item, i) => {
                if (i === index) {
                    return {
                        ...item,
                        ...obj,
                    };
                }
                return item;
            });
        });
    };

    const handleRemoveMessageFromSeries = (index, force = false) => {
        const isUserAgree = force ? true : window.confirm(t("assistant.deleteSeriesElement"));
        if (isUserAgree || force) {
            setMessages((prevState) => {
                return prevState.filter((item, i) => i !== index);
            });
        }
    };

    const handleAddClearMessageForSeries = () => {
        setMessages((prevState) => {
            return [...prevState, { title: "", content: "", media: "", hashtags: [] }];
        });
    };

    const openNotificationSocialNetwork = ({ message, description }) => {
        const key = `open${Date.now()}`;
        const btn = (
            <Space>
                <Button type="primary" size="small" onClick={() => navigate("/profile")}>
                    {t("posts.goToProfile")}
                </Button>
            </Space>
        );
        notificationApi.open({
            message: message || t("functions.error"),
            description: description || t("posts.unknownError"),
            btn,
            key,
        });
    };
    const handleChangeSocialNetworks = (value) => {
        if (!tokens[value.toLowerCase()]) {
            return openNotificationSocialNetwork({
                message: t("functions.error"),
                description: t(`posts.notLinked-${value.toLowerCase()}`),
            });
        }
        snAction((prevState) => {
            if (prevState.includes(value)) {
                return prevState
                    .split(",")
                    .filter((item) => item !== value)
                    .join(",");
            } else {
                if (prevState === "") {
                    return value;
                } else {
                    return `${prevState},${value}`;
                }
            }
        });
    };

    useEffect(() => {
        if (isSNModalOpen && !fbPageId && !tokens) {
            fetchWrapper
                .get(`${baseUrl}/auth/getSocialMediaTokens/`)
                .then((res) => {
                    let filteredSn = [];
                    const filteredToken = {
                        facebook: false,
                        instagram: false,
                        linkedin: false,
                    };
                    res.forEach((token) => {
                        if (token.socialMediaType === "FACEBOOK") {
                            filteredToken.facebook = true;
                            filteredSn.push("Facebook");
                        }
                        if (token.socialMediaType === "INSTAGRAM") {
                            filteredToken.instagram = true;
                            filteredSn.push("Instagram");
                        }
                        if (token.socialMediaType === "LINKEDIN") {
                            filteredToken.linkedin = true;
                            filteredSn.push("LinkedIn");
                        }
                    });
                    setTokens((prevState) => filteredToken);
                    snAction(filteredSn.join(","));
                })
                .catch(() => {});
            fetchWrapper.get(`${baseUrl}/profile/`).then((res) => {
                setFbPageId(res.facebookPageId);
            });
        }
    }, [isSNModalOpen]);

    useEffect(() => {
        const myMessages = messages.filter((item) => !item?.id);
        setMessages([...postMessages, ...myMessages]);
    }, [postMessages]);

    return (
        <>
            {notificationContextHolder}
            <button disabled={disabledButton} className="shadow-md flex items-center justify-center bg-white text-primary hover:bg-violet-500 hover:text-white hover:shadow-lg aspect-square p-1 rounded-full text-md border w-10 h-10 duration-500" onClick={() => setIsSNModalOpen(true)}>
                <ShareAltOutlined />
            </button>
            <Modal
                confirmLoading={isLoading}
                title={t("assistant.createsSeriesPostsFromThisMessageBtn")}
                open={isSNModalOpen}
                onOk={createSeriesPostsFromMessage}
                onCancel={() => setIsSNModalOpen(false)}
                okButtonProps={{
                    disabled: !socialNetworks,
                }}
                okText={t("posts.create")}
                cancelText={t("posts.cancel")}
            >
                <div className="text-center flex flex-col gap-4 justify-center py-4 border-b border-solid border-b-[color:var(--Primary-200,#E9D7FE)]">
                    <div className="pb-4 text-center flex gap-4 justify-center border-b border-solid border-b-[color:var(--Primary-200,#E9D7FE)]">
                        <pre className="text-left !text-xs text-pretty text-wrap font-inherit ">{t("assistant.seriesPostsFromArrayInstruction")}</pre>
                    </div>
                    <div className="text-center flex gap-4 justify-center py-4 border-b border-solid border-b-[color:var(--Primary-200,#E9D7FE)]">
                        <div style={{ opacity: socialNetworks?.includes("LinkedIn") ? 1 : 0.4 }} onClick={() => handleChangeSocialNetworks("LinkedIn")} className="flex flex-col flex-1 cursor-pointer">
                            <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/d25408c5dff59b86cb5e75674b2a798a87cd455bde0adf0ceb8c9a670d1405e8?apiKey=300ff06bbf3a4f5c9c73ca7577720bf1&" className="self-center w-6 aspect-square" />
                            <div className="mt-1">LinkedIn</div>
                        </div>

                        {process.env.REACT_APP_IS_HIDE_FACEBOOK !== "true" && (
                            <div style={{ opacity: socialNetworks?.includes("Facebook") ? 1 : 0.4 }} onClick={() => handleChangeSocialNetworks("Facebook")} className={`flex flex-col flex-1 cursor-pointer ${process.env.REACT_APP_IS_HIDE_FACEBOOK === "true" && "!hidden"}`}>
                                <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/f8432315b7e3752ab28ffd9571f771342eef6b676c1f20e4b8a5e6ee48c70349?apiKey=300ff06bbf3a4f5c9c73ca7577720bf1&" className="self-center w-6 aspect-square" />
                                <div className="mt-1">Facebook</div>
                            </div>
                        )}
                        <div style={{ opacity: socialNetworks?.includes("Instagram") ? 1 : 0.4 }} onClick={() => handleChangeSocialNetworks("Instagram")} className="flex flex-col flex-1 cursor-pointer">
                            <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/497038a4df4615b7ef35db19c49364c0fdcd7e3749f9681fe807b55de2426e88?apiKey=300ff06bbf3a4f5c9c73ca7577720bf1&" className="self-center w-6 aspect-square" />
                            <div className="mt-1">Instagram</div>
                        </div>
                    </div>

                    <div className="flex flex-col gap-5">
                        {messages?.map((message, index) => (
                            <div className="relative flex flex-col gap-2 p-2 border rounded-md" key={index}>
                                <h6 className="text-center font-semibold text-violet-600">
                                    {t("assistant.post")} №{index + 1}
                                </h6>
                                <input placeholder={t("assistant.postThemePlaceholder")} className="w-full border rounded-md p-1" value={message?.title} onChange={(e) => handleEditMessageFromSeries(index, "title", e.target.value)} />
                                <textarea
                                    placeholder={`${t("assistant.postContentPlaceholder")} (${t("assistant.required")})`}
                                    className="w-full resize-none border rounded-md p-3"
                                    rows="4"
                                    value={message?.content}
                                    onChange={(e) => handleEditMessageFromSeries(index, "content", e.target.value)}
                                    onBlur={() => {
                                        if (message?.content?.trim() === "") handleRemoveMessageFromSeries(index, true);
                                    }}
                                />
                                <input placeholder={t("assistant.postHashtagsPlaceholder")} className="w-full border rounded-md p-1" value={message?.hashtags.join(" ")} onChange={(e) => handleEditMessageFromSeries(index, "hashtags", e.target.value)} />
                                <button className="absolute -top-3 -right-3 z-10 text-white bg-red-400 border w-7 h-7 rounded-full shadow-xl hover:bg-red-600" onClick={() => handleRemoveMessageFromSeries(index, message?.content?.trim() === "")}>
                                    <DeleteOutlined />
                                </button>
                            </div>
                        ))}
                        <button disabled={messages.length > 9} className="logout-button !mt-0 disabled:cursor-not-allowed disabled:opacity-50" onClick={handleAddClearMessageForSeries}>
                            {t("assistant.addNewPostToSeries")}
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default CreateSeriesOfPostsFromArrayMessageModal;
